import  { useEffect, useRef, useState } from "react";
import { useApp } from "../../../../context/AppContext";
import { RiShare2Line } from "react-icons/ri";
import {v4 as uuidv4} from "uuid";
import toast from "react-hot-toast";
export default function AskJeevesHome() {
  const baseUrl = "http://localhost:8000/api";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    transcript,
    setTranscript,
    query,
    setQuery,
    chatHistory,
    setChatHistory,
    loading,
    setLoading,
    currentSessionIndex,
    setCurrentSessionIndex,
    voiceMode,
    setVoiceMode,
    setShowVoiceModal,
    fetchCallerData,
  } = useApp();

  const [listening, setListening] = useState(false);
  const [answer, setAnswer] = useState("");
  const [statusMsg, setStatusMsg] = useState("");
  const [askedQuestion, setAskedQuestion] = useState("");
  const recognitionRef = useRef(null);
  const answerRef = useRef(null);
  const streamingIntervalRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [userId, setUserId] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [copyFeedback, setCopyFeedback] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const handleVoiceModeClick = async () => {
    try {
      // Ask for microphone permission
      await navigator.mediaDevices.getUserMedia({ audio: true });

      // ✅ Mic is enabled → toggle voice mode + show modal
      setVoiceMode((prev) => !prev);
      setShowVoiceModal(true);
    } catch (err) {
      console.error("Microphone access denied:", err);
      toast.error("Please enable microphone access to use voice mode.");

      // ❌ Don't open modal if mic blocked
      setVoiceMode(false);
      setShowVoiceModal(false);
    }
  };

  const formatResponse = (response) => response?.replace(/[*_~`]/g, "").trim();

  const stopSpeaking = () => {
    window.speechSynthesis.cancel();
    setIsSpeaking(false);
    setIsPaused(false);
  };

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("userId");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      const newUserId =
        crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`;
      sessionStorage.setItem("userId", newUserId);
      setUserId(newUserId);
    }

    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //voice mode feature//
  useEffect(() => {
    if (!voiceMode) {
      recognitionRef.current?.stop();
      return;
    }

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) return;

    const rec = new SpeechRecognition();
    rec.lang = "en-US";
    rec.interimResults = true;
    let finalTranscript = "";

    rec.onstart = () => setListening(true);

    rec.onresult = (evt) => {
      let interim = "";
      for (let i = 0; i < evt.results.length; i++) {
        const r = evt.results[i];
        if (r.isFinal) finalTranscript += r[0].transcript;
        else interim += r[0].transcript;
      }
      const text = finalTranscript || interim;
      setTranscript(text);
      setQuery(text);
    };

    rec.onend = () => {
      setListening(false);
      if (finalTranscript.trim()) {
        handleAsk(finalTranscript);
        setShowVoiceModal(false);
      }
    };

    recognitionRef.current = rec;
    try {
      rec.start();
    } catch (err) {
      console.error("SpeechRecognition start error:", err);
    }
  }, [voiceMode]);

  // Reset query after answer//
  useEffect(() => {
    if (answer) {
      setQuery("");

      if (voiceMode) setVoiceMode(false);
    }
  }, [answer]);

  const chatEndRef = useRef(null);

  // Scroll to bottom when new question is being asked //
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatHistory, askedQuestion, answer]);

  const startListening = () => {
    if (recognitionRef.current) {
      try {
        recognitionRef.current.start();
      } catch (err) {
        console.error(err);
      }
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setListening(false);
    }
  };

  const tooglePause = () => {
    setIsPaused((prev) => !prev);
    if (!isPaused) {
      window.speechSynthesis.pause();
    } else {
      setIsPaused(false);
      window.speechSynthesis.resume();
    }
  };

  const handleShareClick = async () => {
  const sessionId = localStorage.getItem("currentSessionId");
  // const sessionId = uuidv4(); // generate unique id
  // const link = `${window.location.origin}${window.location.pathname}?sessionId=${sessionId}`;

 try {
    const res = await fetch(`${process.env.REACT_APP_API_PATH}/generate-link`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sessionId }),
    });

    const data = await res.json();

   if (data.success) {
      setShareLink(data.link);
      setShowShareModal(true);
    } else {
      console.error(data.message);
    }
  } catch (error) {
    console.error("Error generating link:", error);
  }
  // setShareLink(link);
  // setShowShareModal(true);
};

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopyFeedback(true);
       setTimeout(() => {
        setCopyFeedback(false);
        setShowShareModal(false);
      }, 2000);
      toast.success("Link copied successfully!");
    }).catch(() => {
      toast.error("Failed to copy link");
    });
  };  

  const handleAsk = async (
    spokenQuery,
    chatSessionIndex = currentSessionIndex,
  ) => {
    const finalQuery = spokenQuery || transcript || query;
    if (!finalQuery) return setStatusMsg("Please enter or speak a question.");
    setStatusMsg("");
    setAnswer("");

    setAskedQuestion(finalQuery);
    setQuery("");
    setTranscript("");
    setLoading(true);

    try {
      let sessionIndexToUse = chatSessionIndex;
      const id = localStorage.getItem("userId");

      if (chatHistory.length === 0 || currentSessionIndex === null) {
        const res = await fetch(`${baseUrl}/new-chat`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        });

        const data = await res.json();

        if (data.chatSession) {
          setChatHistory((prev) => [data.chatSession, ...prev]);
          setCurrentSessionIndex(0);
          sessionIndexToUse = 0;
        }
      }

      const getResponse = await fetch(`${baseUrl}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: finalQuery,
          id: id,
          chatSessionIndex: sessionIndexToUse,
        }),
      });

      if (!getResponse.ok) throw new Error(await getResponse.text());
      const result = await getResponse.json();

      let finalResponse = formatResponse(result?.answer || "");
      if (finalResponse.startsWith(finalQuery)) {
        finalResponse = finalResponse.replace(finalQuery, "").trim();
      }

      const words = finalResponse.split(/\s+/);
      let index = 0;
      let currentText = "";
      let speechBuffer = [];
      setIsGenerating(true);
      clearInterval(streamingIntervalRef.current);

      streamingIntervalRef.current = setInterval(() => {
        if (index < words.length) {
          const word = words[index];
          currentText += (currentText ? " " : "") + word;
          setAnswer(currentText + " …");
          answerRef.current?.scrollIntoView({ behavior: "smooth" });
          if (voiceMode) {
            speechBuffer.push(word);
            if (speechBuffer.length >= 10 || index === words.length - 1) {
              const chunk = speechBuffer.join(" ");
              speechBuffer = [];
              const utter = new SpeechSynthesisUtterance(chunk);
              utter.rate = 1.11;
              utter.pitch = 1;
              utter.volume = 1;
              // make sure modal stays open
              if (!isSpeaking) setIsSpeaking(true);

              // ✅ only close when the *last* chunk is done
              if (index === words.length - 1) {
                utter.onend = () => {
                  setIsSpeaking(false);
                  setIsPaused(false);
                };
              }
              window.speechSynthesis.speak(utter);
            }
          }

          index++;
        } else {
          clearInterval(streamingIntervalRef.current);
          setIsGenerating(false);
          setAnswer(formatResponse(currentText));

          const newMessage = {
            question: finalQuery,
            answer: formatResponse(currentText),
            media: result?.media || [],
          };
          setChatHistory((prev) => {
            const updated = [...prev];
            updated[sessionIndexToUse].messages.push(newMessage);
            return updated;
          });
          setAskedQuestion("");
          setAnswer("");
  setTimeout(() => {
            fetchCallerData();
          }, 7);
        }
      }, 110);
    } catch (err) {
      console.error(err);
      setAnswer(`Something went wrong, try again later!`);
    } finally {
      setLoading(false);
    }
  };


  //  const handleAsk = async (
  //   spokenQuery,
  //   chatSessionIndex = currentSessionIndex
  // ) => {
  //   const finalQuery = spokenQuery || transcript || query;
  //   if (!finalQuery) return setStatusMsg("Please enter or speak a question.");

  //   setStatusMsg("");
  //   setAnswer("");

  //   setAskedQuestion(finalQuery);
  //   setQuery("");
  //   setTranscript("");

  //   setLoading(true);

  //   try {
  //     let sessionIndexToUse = chatSessionIndex;

  //     if (chatHistory.length === 0 || currentSessionIndex === null) {
  //       const res = await fetch(`${baseUrl}/api/new-chat`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ id }),
  //       });

  //       const data = await res.json();
  //       if (data.chatSession) {
  //         setChatHistory((prev) => [data.chatSession, ...prev]);
  //         setCurrentSessionIndex(0);
  //         sessionIndexToUse = 0;
  //       }
  //     }

  //     const getResponse = await fetch(`${baseUrl}/api/chat`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         query: finalQuery,
  //         phone,
  //         chatSessionIndex: sessionIndexToUse,
  //       }),
  //     });

  //     if (!getResponse.ok) throw new Error(await getResponse.text());
  //     const result = await getResponse.json();

  //     const pendingImage =
  //       result?.media?.find((m) => m.type === "image")?.url || null;
  //     const pendingVideo =
  //       result?.media?.find((m) => m.type === "video")?.url || null;

  //     let finalResponse = formatResponse(result?.answer || "");
  //     if (finalResponse.startsWith(finalQuery)) {
  //       finalResponse = finalResponse.replace(finalQuery, "").trim();
  //     }

  //     const chars = finalResponse.split("");
  //     let index = 0;
  //     let currentText = "";
  //     let speechBuffer = [];
  //     const chunkSize = 7; // number of characters per tick (increase for faster typing)
  //     const delay = 32; // interval in ms (decrease for faster typing)

  //     setIsGenerating(true);
  //     clearInterval(streamingIntervalRef.current);

  //     streamingIntervalRef.current = setInterval(() => {
  //       if (index < chars.length) {
  //         // take multiple chars per tick
  //         const chunk = chars.slice(index, index + chunkSize).join("");
  //         currentText += chunk;
  //         setAnswer(currentText); // preserves Markdown formatting
  //         // if (chatWrapperRef.current) {
  //         //   setShowScrollArrow(
  //         //     chatWrapperRef.current.scrollHeight >
  //         //       chatWrapperRef.current.clientHeight
  //         //   );
  //         // }

  //         // smoother scrolling: instant during typing, smooth only at the end
  //         if (index + chunkSize >= chars.length) {
  //           answerRef.current?.scrollIntoView({ behavior: "smooth" }); // final scroll
  //         } else if (index % 20 === 0) {
  //           // throttle intermediate scrolls
  //           answerRef.current?.scrollIntoView({ behavior: "auto" });
  //         }

  //         index += chunkSize; // move by chunk size
  //       } else {
  //         clearInterval(streamingIntervalRef.current);
  //         setIsGenerating(false);
  //         setAnswer(formatResponse(currentText));

  //         const newMessage = {
  //           question: finalQuery,
  //           answer: formatResponse(currentText),
  //           media: result?.media || [],
  //         };
  //         setChatHistory((prev) => {
  //           const updated = [...prev];
  //           updated[sessionIndexToUse].messages.push(newMessage);
  //           return updated;
  //         });
  //         setAskedQuestion("");
  //         setAnswer("");

  //         // small defer to avoid UI shake
  //         setTimeout(() => {
  //           fetchCallerData();
  //         }, 7);
  //       }
  //     }, delay);

  //     if (voiceMode) {
  //       setShowVoiceModeModal(true);

  //       // Split text into sentences
  //       const sentences = finalResponse.match(/[^.!?]+[.!?]+/g) || [
  //         finalResponse,
  //       ];
  //       let sIndex = 0;

  //       const speakNextSentence = () => {
  //         if (sIndex < sentences.length) {
  //           const sentence = sentences[sIndex++].trim();
  //           if (!sentence) return speakNextSentence();

  //           const utter = new SpeechSynthesisUtterance(sentence);
  //           utter.rate = 1.15; // a bit slower, more natural
  //           utter.pitch = 1;
  //           utter.volume = 1;

  //           if (!isSpeaking) setIsSpeaking(true);

  //           utter.onend = () => speakNextSentence();

  //           window.speechSynthesis.speak(utter);
  //         } else {
  //           setIsSpeaking(false);
  //           setIsPaused(false);
  //         }
  //       };

  //       speakNextSentence();
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     setAnswer(`Something went wrong, try again later!`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  return (
    <div className="flex">
      <div className=" flex-1   flex flex-col  items-center justify-center   p-6 h-[100%]">
              <div className="absolute right-10 top-10 justify-end">
          <div 
            className="flex items-center gap-2 cursor-pointer hover:text-blue-600 transition-colors"
            onClick={handleShareClick}
          >
                <RiShare2Line size={25} /> 
                <span>Share</span>
          </div>
        </div>
            <div className="min-h-screen lg:pl-64 flex flex-col items-center justify-center pb-10  w-full  ">
              <div className=" text-center text-lg font-semibold mb-4 ">
                <div className="flex items-center justify-center">
                  <svg
                    className="w-12 h-12"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    stroke="none"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4 18h2v4.081L11.101 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2z"></path>
                    <path d="M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"></path>
                  </svg>
                </div>

                <h2 className="text-xl font-bold ">
                  Welcome 👋 Ask anything
                </h2>
              </div>
              <div
                className="max-w-3xl w-full flex flex-col gap-4 pb-4 overflow-y-auto"
                id="chatContainer"
              >
                {chatHistory && chatHistory[currentSessionIndex]?.messages?.map(
                  (chat, idx) => (
                    <div key={idx} className="flex flex-col gap-1">
                      <div className="self-end bg-gray-200 px-4 py-2 rounded-2xl max-w-xs break-words mb-4">
                        {chat.question}
                      </div>
                      <div className="self-start bg-[#F9F9F9] px-4 py-2 rounded-2xl max-w-3xl break-words whitespace-pre-line">
                        {formatResponse(chat.answer)}
                      </div>
                    </div>
                  ),
                )}
                {askedQuestion && (
                  <div className="self-end bg-gray-200 px-4 py-2 rounded-2xl max-w-xs break-words mb-4">
                    {askedQuestion}
                  </div>
                )}
                {/* Live streaming answer */}
                {(loading || answer) && (
                  <div
                    ref={answerRef}
                    className="self-start bg-[#F9F9F9] px-4 py-2 rounded-2xl max-w-3xl break-words whitespace-pre-line mb-24"
                  >
                    {formatResponse(answer) ||
                      (loading && (
                        <span className="flex space-x-1">
                          <span className="dot bg-gray-600 w-2 h-2 rounded-full animate-bounce"></span>
                          <span className="dot bg-gray-600 w-2 h-2 rounded-full animate-bounce [animation-delay:200ms]"></span>
                          <span className="dot bg-gray-600 w-2 h-2 rounded-full animate-bounce [animation-delay:400ms]"></span>
                        </span>
                      ))}
                  </div>
                )}

                {/* Invisible div to scroll into view */}
                <div ref={chatEndRef} />
              </div>

              <div
                className={
                 chatHistory && chatHistory[currentSessionIndex]?.messages.length > 0 ||
                  askedQuestion
                    ? "fixed z-10 bottom-8 left-1.7 w-full px-4 py-3 pt-5 flex justify-center items-center"
                    : "w-full flex justify-center items-center"
                }
              >
                <div className="relative w-full max-w-3xl mt-6 z-10">
                  <input
                    value={query || transcript}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                      e.key === "Enter" &&
                        handleAsk(undefined, currentSessionIndex);
                    }}
                    placeholder="Ask Me Anything"
                    className="w-full border border-gray-300 rounded-full p-3 pr-36 focus:outline-none focus:ring-2 focus:ring-gray-500 z-0"
                  />
                  <button
                    onClick={() => {
                      handleAsk(undefined, currentSessionIndex);
                    }}
                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-gray-600 text-white px-4 py-2 rounded-full hover:bg-gray-700"
                  >
                    {isGenerating ? (
                      <svg
                        class="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        data-slot="icon"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    ) : (
                      "Ask"
                    )}
                  </button>

                  <div className="absolute right-[74px] top-1/2 -translate-y-1/2 group">
                    <button
                      onClick={handleVoiceModeClick}
                      className={`px-3 py-2 rounded-full border ${
                        voiceMode
                          ? "bg-green-200 border-green-400"
                          : "bg-white border-gray-300"
                      }`}
                    >
                      <svg
                        className="w-6 h-6"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 4L12 20"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M8 9L8 15"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M20 10L20 14"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M4 10L4 14"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M16 7L16 17"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                    <span
                      className="absolute  top-12 mb-2 left-1/2 transform -translate-x-1/2
                     bg-gray-800 text-white text-sm rounded px-2 py-1
                     opacity-0 group-hover:opacity-100 transition-opacity duration-300
                     pointer-events-none whitespace-nowrap"
                    >
                      Use Voice Mode
                    </span>
                  </div>

                  <div className="absolute right-32 top-1/2 -translate-y-1/2 group">
                    <button
                      onClick={listening ? stopListening : startListening}
                      className={`px-3 py-2 rounded-full border ${
                        listening
                          ? "bg-red-100 border-red-400"
                          : "bg-white border-gray-300"
                      }`}
                    >
                      <svg
                        className="w-6 h-6"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="48"
                          height="48"
                          fill="white"
                          fillOpacity="0.01"
                        ></rect>
                        <rect
                          x="17"
                          y="4"
                          width="14"
                          height="27"
                          rx="7"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinejoin="round"
                        ></rect>
                        <path
                          d="M9 23C9 31.2843 15.7157 38 24 38C32.2843 38 39 31.2843 39 23"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M24 38V44"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                    <span
                      className="absolute top-12 mb-2 left-1/2 transform -translate-x-1/2
                     bg-gray-800 text-white text-sm rounded px-2 py-1
                     opacity-0 group-hover:opacity-100 transition-opacity duration-300
                     pointer-events-none whitespace-nowrap"
                    >
                      Dictate
                    </span>
                  </div>
                </div>
              </div>
              <div className="fixed bottom-4 right-4 flex gap-2 z-50">
                {/* Stop button */}
                {isSpeaking && (
                  <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center z-50">
                    {/* Modal content */}
                    <div className="flex flex-col items-center gap-6">
                      {/* Buttons: Pause / Resume / Stop */}
                      <div className="flex gap-4">
                        {/* Stop button */}
                        <button
                          onClick={stopSpeaking}
                          className="bg-red-600 text-white h-12 w-12  rounded-full hover:bg-red-700 flex justify-center items-center"
                        >
                          <svg
                            class="w-6 h-6"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5"></path>
                          </svg>
                        </button>
                        {/* Pause button */}
                        {!isPaused ? (
                          <button
                            onClick={tooglePause}
                            className="bg-yellow-500 text-white h-12 w-12 rounded-full hover:bg-yellow-600 flex justify-center items-center"
                          >
                            <svg
                              class="w-6 h-6"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 320 512"
                            >
                              <path d="M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"></path>
                            </svg>
                          </button>
                        ) : (
                          <button
                            onClick={tooglePause}
                            className="bg-green-600 text-white w-12 h-12 rounded-full hover:bg-green-700 flex justify-center items-center"
                          >
                            <svg
                              class="w-6 h-6"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path d="M4 4l12 6-12 6z"></path>
                            </svg>
                          </button>
                        )}
                        {/* Resume button */}
                        {/* {isPaused && (
                    
                    )} */}
                      </div>
                    </div>
                    {/* Close button at bottom */}
                    <button
                      onClick={stopSpeaking} // or you can create a separate closeModal()
                      className="absolute bottom-8 bg-gray-700 text-white px-6 py-2 rounded-full hover:bg-gray-800"
                    >
                      ✕ Close
                    </button>
                  </div>
                )}
              </div>

              {showScrollButton && (
              <button
                onClick={scrollToTop}
                className="fixed bottom-6 right-6 bg-gray-700 text-white p-3 rounded-full shadow-lg hover:bg-gray-800 transition z-40"
              >
                <svg
                  class="w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <polygon points="9 3.828 2.929 9.899 1.515 8.485 10 0 10.707 .707 18.485 8.485 17.071 9.899 11 3.828 11 20 9 20 9 3.828"></polygon>
                </svg>
              </button>
            )}
          </div>
        </div>

      {/* Share Modal */}
      {showShareModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Share Chat Session</h2>
              <button
                onClick={() => setShowShareModal(false)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ✕
              </button>
            </div>

            <div className="mb-4">
              <p className="text-gray-600 text-sm mb-3">
                Share this link to let others view your chat session:
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={shareLink}
                  readOnly
                  className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm bg-gray-50"
                />
                <button
                  onClick={handleCopyLink}
                  className={`px-4 py-2 rounded font-semibold transition-colors ${
                    copyFeedback
                      ? "bg-green-500 text-white"
                      : "bg-blue-600 text-white hover:bg-blue-700"
                  }`}
                >
                  {copyFeedback ? "✓ Copied" : "Copy"}
                </button>
              </div>
            </div>

            <button
              onClick={() => setShowShareModal(false)}
              className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
